module.exports = __webpack_public_path__ + "img/T2B_rc_8.ac4701bf.png";